import { inject, InjectionToken } from "@angular/core";
import { VdsDrawerConfig } from "./drawer-config";
import { Overlay, ScrollStrategy } from "@angular/cdk/overlay";

export const VDS_DRAWER_DATA = new InjectionToken<any>("VdsDrawerData");
export const VDS_DRAWER_DEFAULT_OPTIONS = new InjectionToken<VdsDrawerConfig>("vds-drawer-default-options");

export const VDS_DRAWER_SCROLL_STRATEGY = new InjectionToken<() => ScrollStrategy>("vds-dialog-scroll-strategy", {
    providedIn: "root",
    factory: () => {
        const overlay = inject(Overlay);
        return () => overlay.scrollStrategies.block();
    }
});
